const marqueeBanner = () => ({
    init() {
        this.Marquee('.info-banner__list-wrapper .info-banner__list', 0.2)
    },
    Marquee(selector, speed) {
        document.querySelectorAll(selector)?.forEach(parentMarqueeWrapper => {
            let clone = parentMarqueeWrapper.innerHTML;
            let firstElement = parentMarqueeWrapper.children[0];
            let i = 0;
            parentMarqueeWrapper.insertAdjacentHTML('beforeend', clone);
            parentMarqueeWrapper.insertAdjacentHTML('beforeend', clone);

            setInterval(function () {
                firstElement.style.marginLeft = `-${i}px`;
                if (i > firstElement.clientWidth) {
                    i = 0;
                }
                i = i + speed;
            }, 0);
        });
    }
})

export default marqueeBanner